import React from "react";
import Header from "./Header";
import Hero from "./Hero";
import Explainer from "./Explainer";
import Features from "./Features";
import Pricing from "./Pricing";
import Testimonials from "./Testimonials";
import Footer from "./Footer";

export default function LandingPage() {
  return (
    <div className="bg-white min-h-screen">
      <Header />
      <main>
        <Hero />
        <Features />
        <Explainer />
        <Pricing />
        {/* Testimonials section hidden for now */}
        {/* <Testimonials /> */}
      </main>
      <Footer />
    </div>
  );
}
